import { useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import buildUrl from "build-url";

import { useDevice, useRating, useUser, useConfig } from "utils/hooks";
import { REVIVE_HOST, REVIVE_PATH, SHOW_ZONE_NAMES_KEY } from "utils/constants";
import { isPremium, isSuperUser } from "utils/misc";

export default function useContent(contentIds = []) {
  const { user } = useUser();
  const { config, loading: loadingConfig } = useConfig();
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState({});

  async function fetchContent() {
    // Don't need to fetch for these two
    if ((isPremium(user) || isSuperUser(user)) && !localStorage.getItem(SHOW_ZONE_NAMES_KEY)) {
      if (loading === true) {
        setLoading(false);
      }

      return;
    }

    setLoading(true);

    try {
      const localZones = contentIds.filter(id => !!config.zones[id]);
      const remoteZones = localZones.map(id => config.zones[id]);

      if (remoteZones.length === 0) {
        throw new Error("No valid zones found");
      }

      const url = buildUrl(`//${REVIVE_HOST}${REVIVE_PATH}`, {
        queryParams: {
          zones: remoteZones.join("|"),
          loc: location.href,
        }
      });

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        const mapped = data.reduce((all, item, index) => {
          const id = localZones[index];
          all[id] = item.html;
          return all;
        }, {});

        setResults(mapped);
      }
    } catch (err) {
      console.error("Fetch ads error", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!loadingConfig && config?.zones) {
      fetchContent();
    }
  }, [contentIds, loadingConfig, config]);

  return results ?? {};
}
